/* PHOS — theme.js
   Cart, accordions, tabs, quiz, bundle, reveal, cursor, nav. */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var fmtMoney = function (cents) {
    return '$' + (cents / 100).toFixed(2);
  };

  /* ─────────────────  REVEAL ───────────────── */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    var observe = function () { $$('.reveal:not(.in)').forEach(function (el) { io.observe(el); }); };
    observe();
    document.addEventListener('shopify:section:load', observe);
  } else {
    $$('.reveal').forEach(function (el) { el.classList.add('in'); });
  }

  /* ─────────────────  NAV scrolled ───────────────── */
  var nav = $('#site-nav');
  if (nav) {
    var onScroll = function () { nav.classList.toggle('nav--scrolled', window.scrollY > 24); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ─────────────────  CURSOR ───────────────── */
  var cur = $('.cur'), curR = $('.cur-r');
  if (cur && curR && !window.matchMedia('(pointer:coarse)').matches) {
    var x = 0, y = 0, rx = 0, ry = 0;
    document.addEventListener('mousemove', function (e) { x = e.clientX; y = e.clientY; cur.style.transform = 'translate(' + (x - 4) + 'px,' + (y - 4) + 'px)'; });
    var loop = function () {
      rx += (x - rx) * 0.18; ry += (y - ry) * 0.18;
      curR.style.transform = 'translate(' + (rx - 18) + 'px,' + (ry - 18) + 'px)';
      requestAnimationFrame(loop);
    };
    loop();
    var hoverTargets = 'a, button, [role=button], input, select, textarea, .ing-cell, .bb-card, .quiz-opt, .pdp-thumb, .pdp-option-val';
    document.addEventListener('mouseover', function (e) {
      if (e.target.closest && e.target.closest(hoverTargets)) document.body.classList.add('cur-active');
    });
    document.addEventListener('mouseout', function (e) {
      if (e.target.closest && e.target.closest(hoverTargets)) document.body.classList.remove('cur-active');
    });
  }

  /* ─────────────────  MARQUEE — clone for seamless loop already done by Liquid ───────────────── */

  /* ─────────────────  TOAST ───────────────── */
  var toastEl = $('[data-toast]');
  var toastMsg = $('[data-toast-msg]');
  var toastTimer;
  var toast = function (msg) {
    if (!toastEl || !toastMsg) return;
    toastMsg.textContent = msg;
    toastEl.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('show'); }, 2400);
  };

  /* ─────────────────  CART ───────────────── */
  var drawer = $('[data-cart-drawer]');
  var overlay = $('[data-cart-overlay]');
  var openCart = function () {
    if (!drawer) return;
    drawer.classList.add('open'); drawer.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  };
  var closeCart = function () {
    if (!drawer) return;
    drawer.classList.remove('open'); drawer.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.classList.remove('open');
    document.body.style.overflow = '';
  };
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openCart(); }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeCart(); }
    if (e.target === overlay) closeCart();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });

  var refreshCart = function (cb) {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // counts
        $$('[data-cart-count]').forEach(function (el) {
          var n = String(cart.item_count).padStart(2, '0').slice(-2);
          el.textContent = '[' + n + ']';
        });
        $$('[data-cart-count-text]').forEach(function (el) { el.textContent = cart.item_count + ' items'; });
        $$('[data-cart-subtotal]').forEach(function (el) { el.textContent = fmtMoney(cart.total_price); });
        $$('[data-cart-total]').forEach(function (el) { el.textContent = fmtMoney(cart.total_price); });
        var foot = $('[data-cart-foot]');
        if (foot) foot.style.display = cart.item_count === 0 ? 'none' : '';
        // re-fetch the drawer body HTML
        return fetch('/?sections=cart-drawer-body', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).catch(function () { return null; });
      })
      .then(function () {
        // Fallback: rebuild drawer body via cart sections endpoint
        return fetch('/cart?view=drawer', { headers: { Accept: 'text/html' } }).catch(function () { return null; });
      })
      .then(function () { if (cb) cb(); })
      .catch(function (err) { console.error('Cart refresh failed', err); });
  };

  // simpler refresh: re-fetch cart.js + rebuild cart body via Liquid section render API
  var rebuildCartBody = function () {
    var body = $('[data-cart-body]');
    if (!body) return Promise.resolve();
    return fetch('/?section_id=cart-drawer-body', { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        // The section endpoint isn't standard for snippets; use the cart page render instead via /cart with a partial.
        // Just re-render lines from /cart.js (simpler, no section dependency).
      })
      .catch(function () { /* ignore */ });
  };

  // Build cart body from cart.js JSON (works without section render API)
  var renderCartBody = function (cart) {
    var body = $('[data-cart-body]');
    if (!body) return;
    if (cart.item_count === 0) {
      body.innerHTML = '<div class="cart-empty"><p>Your ritual awaits.</p><a class="btn btn--primary" href="/collections/all">Begin <span class="arrow">→</span></a></div>';
      return;
    }
    var html = '';
    cart.items.forEach(function (item) {
      var planName = (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan && item.selling_plan_allocation.selling_plan.name) || 'One-time';
      var variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title + ' · ' : '';
      var img = item.image ? item.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_160x$1$2') : '';
      html += '<div class="cart-line" data-line-key="' + item.key + '">'
        + '<div class="img"><a href="' + item.url + '"><img src="' + img + '" alt=""></a></div>'
        + '<div style="display:flex;flex-direction:column;flex:1">'
        + '<h5><a href="' + item.url + '">' + item.product_title + '</a></h5>'
        + '<div class="meta">' + variantTitle + planName + '</div>'
        + '<div class="row">'
        + '<div class="cart-qty">'
        + '<button type="button" data-cart-qty="' + item.key + '" data-delta="-1">−</button>'
        + '<span>' + item.quantity + '</span>'
        + '<button type="button" data-cart-qty="' + item.key + '" data-delta="1">+</button>'
        + '</div>'
        + '<div class="price">' + fmtMoney(item.final_line_price) + '</div>'
        + '</div>'
        + '<button type="button" class="cart-rem" data-cart-remove="' + item.key + '">Remove</button>'
        + '</div>'
        + '</div>';
    });
    body.innerHTML = html;
  };

  var syncCart = function () {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) {
          var n = String(cart.item_count).padStart(2, '0').slice(-2);
          el.textContent = '[' + n + ']';
        });
        $$('[data-cart-count-text]').forEach(function (el) { el.textContent = cart.item_count + ' items'; });
        $$('[data-cart-subtotal]').forEach(function (el) { el.textContent = fmtMoney(cart.total_price); });
        $$('[data-cart-total]').forEach(function (el) { el.textContent = fmtMoney(cart.total_price); });
        var foot = $('[data-cart-foot]');
        if (foot) foot.style.display = cart.item_count === 0 ? 'none' : '';
        renderCartBody(cart);
        return cart;
      });
  };

  // Add-to-cart for ajax forms
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-ajax-form]');
    if (!form) return;
    e.preventDefault();
    var fd = new FormData(form);
    var btn = form.querySelector('button[type=submit]');
    if (btn) btn.disabled = true;
    fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, data: j }; }); })
      .then(function (res) {
        if (!res.ok) {
          toast(res.data.description || res.data.message || 'Could not add');
          return;
        }
        return syncCart().then(function () {
          toast('Added to ritual');
          openCart();
        });
      })
      .catch(function () { toast('Network error'); })
      .finally(function () { if (btn) btn.disabled = false; });
  });

  // Cart qty + remove (delegated)
  document.addEventListener('click', function (e) {
    var qtyBtn = e.target.closest('[data-cart-qty]');
    var remBtn = e.target.closest('[data-cart-remove]');
    if (qtyBtn) {
      var key = qtyBtn.getAttribute('data-cart-qty');
      var delta = parseInt(qtyBtn.getAttribute('data-delta'), 10);
      var line = qtyBtn.closest('[data-line-key]');
      var cur = line ? parseInt(line.querySelector('.cart-qty span').textContent, 10) : 1;
      var next = Math.max(0, cur + delta);
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: next })
      }).then(syncCart);
    } else if (remBtn) {
      var key2 = remBtn.getAttribute('data-cart-remove');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key2, quantity: 0 })
      }).then(syncCart);
    }
  });

  /* ─────────────────  PDP ───────────────── */
  var pdpForm = $('[data-pdp-form]');
  if (pdpForm) {
    var variantInput = $('[data-variant-input]', pdpForm);
    var planInput = $('[data-selling-plan-input]', pdpForm);
    var qtyInput = $('[data-qty-input]', pdpForm);
    var totalEl = $('[data-pdp-total]', pdpForm);
    var variantsScript = $('[data-pdp-variants]');
    var variants = variantsScript ? JSON.parse(variantsScript.textContent) : null;
    var selectedOptions = [];
    if (variants) {
      $$('.pdp-option', pdpForm).forEach(function (opt, i) {
        var active = $('.pdp-option-val.active', opt);
        selectedOptions[i] = active ? active.getAttribute('data-option-value') : (opt.querySelector('.pdp-option-val') && opt.querySelector('.pdp-option-val').getAttribute('data-option-value'));
      });
    }
    var findVariant = function () {
      if (!variants) return null;
      return variants.find(function (v) {
        return selectedOptions.every(function (val, i) { return v.options[i] === val; });
      }) || null;
    };
    var refreshPDP = function () {
      var v = findVariant();
      if (v) {
        variantInput.value = v.id;
        var qty = parseInt(qtyInput.value, 10) || 1;
        var mode = pdpForm.querySelector('input[name=purchase_mode]:checked');
        var isSub = mode && mode.value === 'subscribe';
        var price = v.price;
        var subAlloc = (v.selling_plan_allocations || [])[0];
        if (isSub && subAlloc) price = subAlloc.price;
        if (totalEl) totalEl.textContent = fmtMoney(price * qty);
      }
    };

    // Option buttons
    $$('.pdp-option-val', pdpForm).forEach(function (b) {
      b.addEventListener('click', function () {
        var idx = parseInt(b.getAttribute('data-option-index'), 10);
        $$('.pdp-option-val[data-option-index="' + idx + '"]', pdpForm).forEach(function (s) { s.classList.remove('active'); });
        b.classList.add('active');
        selectedOptions[idx] = b.getAttribute('data-option-value');
        refreshPDP();
      });
    });

    // Subscribe / one-time toggle
    $$('.buy-mode-opt', pdpForm).forEach(function (lbl) {
      lbl.addEventListener('click', function () {
        $$('.buy-mode-opt', pdpForm).forEach(function (l) { l.classList.remove('active'); });
        lbl.classList.add('active');
        var input = lbl.querySelector('input[type=radio]');
        if (input) input.checked = true;
        var isSub = input && input.value === 'subscribe';
        var subInterval = $('[data-sub-interval]', pdpForm);
        if (subInterval) subInterval.style.display = isSub ? '' : 'none';
        if (planInput) {
          if (isSub) {
            var sel = $('[data-selling-plan-select]', pdpForm);
            planInput.value = sel ? sel.value : (window.__phosDefaultPlan || '');
          } else {
            planInput.value = '';
          }
        }
        refreshPDP();
      });
    });

    var planSelect = $('[data-selling-plan-select]', pdpForm);
    if (planSelect) {
      planSelect.addEventListener('change', function () {
        if (planInput) planInput.value = planSelect.value;
        refreshPDP();
      });
    }

    // Default to subscribe selected
    if (planInput && window.__phosDefaultPlan) planInput.value = window.__phosDefaultPlan;

    // Qty
    $$('[data-qty-delta]', pdpForm).forEach(function (b) {
      b.addEventListener('click', function () {
        var d = parseInt(b.getAttribute('data-qty-delta'), 10);
        qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + d);
        refreshPDP();
      });
    });
    qtyInput.addEventListener('input', refreshPDP);

    // Thumbs + arrows + crossfade layers
    var thumbs = $$('[data-pdp-thumb]');
    var layers = $$('[data-pdp-layer]');
    var numEl = $('[data-pdp-num]');
    var total = layers.length;
    var setActive = function (idx) {
      idx = (idx + total) % total;
      layers.forEach(function (l, i) { l.classList.toggle('is-on', i === idx); });
      thumbs.forEach(function (s, i) { s.classList.toggle('active', i === idx); });
      if (numEl) numEl.textContent = String(idx + 1).padStart(2, '0') + ' / ' + String(total).padStart(2, '0');
    };
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { setActive(i); }); });
    var curIdx = function () { return Math.max(0, layers.findIndex(function (l) { return l.classList.contains('is-on'); })); };
    var prevBtn = $('[data-pdp-prev]');
    var nextBtn = $('[data-pdp-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { setActive(curIdx() - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { setActive(curIdx() + 1); });

    refreshPDP();
  }

  /* ───────────────── REVIEWS SCROLL LINK ───────────────── */
  $$('[data-scroll-reviews]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
      var r = document.querySelector('.review-marquee, .pdp-extra');
      if (r) window.scrollTo(0, r.getBoundingClientRect().top + window.scrollY - 80);
    });
  });

  /* ─────────────────  PDP TABS ───────────────── */
  $$('[data-tabs]').forEach(function (tabs) {
    var section = tabs.parentElement;
    $$('.tab', tabs).forEach(function (b) {
      b.addEventListener('click', function () {
        var id = b.getAttribute('data-tab');
        $$('.tab', tabs).forEach(function (s) { s.classList.remove('active'); });
        b.classList.add('active');
        $$('[data-tab-panel]', section).forEach(function (p) {
          p.classList.toggle('hidden', p.getAttribute('data-tab-panel') !== id);
        });
      });
    });
  });

  /* ─────────────────  INGREDIENT EXPAND ───────────────── */
  $$('.ing-cell[data-toggle]').forEach(function (cell) {
    cell.addEventListener('click', function () {
      var was = cell.classList.contains('expanded');
      $$('.ing-cell[data-toggle]').forEach(function (c) { c.classList.remove('expanded'); });
      if (!was) cell.classList.add('expanded');
    });
  });

  /* ─────────────────  FAQ ───────────────── */
  $$('[data-faq-q]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.faq-item');
      var was = item.classList.contains('open');
      // Close others in same section
      var section = item.closest('.faq-section');
      if (section) $$('.faq-item.open', section).forEach(function (i) { if (i !== item) i.classList.remove('open'); });
      item.classList.toggle('open', !was);
    });
  });

  /* ─────────────────  REVIEWS CAROUSEL ───────────────── */
  $$('[data-review-track]').forEach(function (track) {
    var section = track.closest('.section');
    var counter = $('[data-review-counter]', section);
    var prev = $('[data-review-prev]', section);
    var next = $('[data-review-next]', section);
    var total = track.children.length;
    var idx = 0;
    var setIdx = function (i) {
      idx = Math.max(0, Math.min(total - 1, i));
      var card = track.querySelector('.rcard');
      var w = card ? card.offsetWidth + 24 : 380;
      track.scrollTo({ left: idx * w, behavior: 'smooth' });
      if (counter) counter.textContent = String(idx + 1).padStart(2, '0') + ' / ' + String(total).padStart(2, '0');
      if (prev) prev.disabled = idx === 0;
      if (next) next.disabled = idx >= total - 1;
    };
    if (prev) prev.addEventListener('click', function () { setIdx(idx - 1); });
    if (next) next.addEventListener('click', function () { setIdx(idx + 1); });
    setIdx(0);
  });

  /* ─────────────────  BUNDLE (qty tiers) ───────────────── */
  $$('[data-bundle-qty]').forEach(function (root) {
    var unitCents = parseInt(root.getAttribute('data-unit-cents'), 10) || 0;
    var symbol = root.getAttribute('data-currency-symbol') || '$';
    var variantId = parseInt(root.getAttribute('data-variant'), 10) || 0;
    var tiers = $$('[data-tier]', root);
    var totalEl = $('[data-bundle-total]', root);
    var compareEl = $('[data-bundle-compare]', root);
    var savingsEl = $('[data-bundle-savings]', root);
    var qtyLabel = $('[data-bundle-qty-label]', root);
    var addBtn = $('[data-bundle-qty-add]', root);

    var fmt = function (cents) {
      return symbol + (cents / 100).toFixed(2);
    };

    var state = { qty: 2, disc: 0 };

    var apply = function () {
      var gross = unitCents * state.qty;
      var net = Math.round(gross * (1 - state.disc / 100));
      var savings = gross - net;
      if (totalEl) totalEl.textContent = fmt(net);
      if (compareEl) compareEl.textContent = state.disc > 0 ? fmt(gross) : '';
      if (savingsEl) savingsEl.textContent = state.disc > 0
        ? 'You save ' + fmt(savings) + ' (' + state.disc + '%)'
        : 'No discount on a single bottle';
      if (qtyLabel) qtyLabel.textContent = state.qty;
    };

    tiers.forEach(function (t) {
      t.addEventListener('click', function () {
        tiers.forEach(function (x) {
          x.classList.remove('is-selected');
          x.setAttribute('aria-pressed', 'false');
        });
        t.classList.add('is-selected');
        t.setAttribute('aria-pressed', 'true');
        state.qty = parseInt(t.getAttribute('data-qty'), 10) || 1;
        state.disc = parseFloat(t.getAttribute('data-discount')) || 0;
        apply();
      });
    });

    // initial state from preselected tier
    var pre = tiers.filter(function (t) { return t.classList.contains('is-selected'); })[0] || tiers[0];
    if (pre) {
      state.qty = parseInt(pre.getAttribute('data-qty'), 10) || 1;
      state.disc = parseFloat(pre.getAttribute('data-discount')) || 0;
    }
    apply();

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        if (!variantId) {
          toast('Set the bundle product handle in theme settings');
          return;
        }
        addBtn.disabled = true;
        var props = {};
        if (state.disc > 0) {
          props['Bundle'] = state.qty + '-bottle set (−' + state.disc + '%)';
        }
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: state.qty, properties: props }] })
        }).then(function (r) { return r.json(); })
          .then(function () { return syncCart(); })
          .then(function () { toast('Added ' + state.qty + ' bottle' + (state.qty > 1 ? 's' : '')); openCart(); })
          .catch(function () { toast('Could not add to cart'); })
          .finally(function () { addBtn.disabled = false; });
      });
    }
  });

  /* ─────────────────  QUIZ ───────────────── */
  $$('[data-quiz]').forEach(function (root) {
    var dataEl = $('[data-quiz-data]', root);
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { console.error(e); return; }
    var Qs = data.questions || [];
    var Rs = data.results || [];
    var Ps = data.products || {};
    var fallbackImg = data.fallback_image || '';
    var mount = $('[data-quiz-mount]', root);
    var step = 0;
    var answers = {};
    var done = false;

    var renderStep = function () {
      done = step >= Qs.length;
      if (done) return renderResult();
      var q = Qs[step];
      mount.innerHTML = '<div class="quiz-progress"><span>Step ' + String(step + 1).padStart(2, '0') + ' / ' + String(Qs.length).padStart(2, '0') + '</span><span>' + q.opts.length + ' answers</span></div>'
        + '<div class="quiz-progress-bar"><span style="position:absolute;inset:0;background:var(--gold);width:' + ((step / Qs.length) * 100) + '%"></span></div>'
        + '<h1 class="quiz-q reveal in" style="margin-top:48px">' + q.q.split(' ').slice(0, -1).join(' ') + ' <em>' + q.q.split(' ').slice(-1)[0] + '</em></h1>'
        + '<p class="quiz-sub reveal in">' + (q.sub || '') + '</p>'
        + '<div class="quiz-options reveal in">'
        + q.opts.map(function (o) {
          var sel = answers[step] === o.v ? ' selected' : '';
          return '<button type="button" class="quiz-opt' + sel + '" data-v="' + o.v + '"><span class="label">' + o.label + '</span><span class="meta">' + (o.meta || '') + '</span></button>';
        }).join('')
        + '</div>'
        + '<div class="quiz-controls">'
        + '<button type="button" class="btn btn--text" data-quiz-back' + (step === 0 ? ' disabled' : '') + '>← Back</button>'
        + '<button type="button" class="btn btn--primary" data-quiz-next' + (answers[step] === undefined ? ' disabled' : '') + '>' + (step === Qs.length - 1 ? 'See your routine' : 'Next') + ' <span class="arrow">→</span></button>'
        + '</div>';
    };

    var renderResult = function () {
      var goal = answers[0];
      var result = Rs.find(function (r) { return r.match === goal; }) || Rs.find(function (r) { return r.match === 'default'; }) || Rs[0];
      if (!result) return;
      var firstHandle = (result.handles || [])[0] && (result.handles[0] || '').trim();
      var firstP = firstHandle ? Ps[firstHandle] : null;
      var img = firstP ? firstP.image : fallbackImg;
      mount.innerHTML = '<div class="quiz-result reveal in">'
        + '<div class="eyebrow"><span class="rule"></span>Your routine · prescribed</div>'
        + '<h2 style="margin-top:14px">The <em>' + result.name + '</em></h2>'
        + '<p>' + result.sub + '. Based on your answers, this is the smallest, most useful version of the PHOS ritual for you.</p>'
        + '<div class="quiz-result-card">'
        + '<div class="img"><img src="' + img + '" alt=""></div>'
        + '<div style="text-align:left">'
        + '<div class="eyebrow">Prescribed for you</div>'
        + '<h3 class="h3" style="margin-top:8px;margin-bottom:14px">' + result.name + '</h3>'
        + '<p style="font-family:var(--sans);font-weight:300;font-size:14px;color:var(--warm);line-height:1.7;margin-bottom:24px">' + result.sub + ' — formulated to address what you told us. 30-day promise.</p>'
        + '<div style="display:flex;gap:12px;flex-wrap:wrap">'
        + '<button type="button" class="btn btn--primary" data-quiz-add>Add & subscribe <span class="arrow">→</span></button>'
        + (firstP ? '<a class="btn btn--ghost" href="' + firstP.url + '">Read more</a>' : '')
        + '</div>'
        + '</div>'
        + '</div>'
        + '<button type="button" class="btn btn--text" style="margin-top:32px" data-quiz-restart>Retake quiz</button>'
        + '</div>';

      var addBtn = $('[data-quiz-add]', mount);
      if (addBtn) addBtn.addEventListener('click', function () {
        var items = (result.handles || []).map(function (h) {
          var k = (h || '').trim();
          var p = Ps[k];
          return p ? { id: p.variantId, quantity: 1 } : null;
        }).filter(Boolean);
        if (items.length === 0) { toast('Set up products first'); return; }
        addBtn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) { return r.json(); })
          .then(function () { return syncCart(); })
          .then(function () { toast('Added your routine'); openCart(); })
          .finally(function () { addBtn.disabled = false; });
      });
      var restartBtn = $('[data-quiz-restart]', mount);
      if (restartBtn) restartBtn.addEventListener('click', function () { step = 0; answers = {}; done = false; renderStep(); });
    };

    mount.addEventListener('click', function (e) {
      var opt = e.target.closest('.quiz-opt');
      var nx = e.target.closest('[data-quiz-next]');
      var bk = e.target.closest('[data-quiz-back]');
      if (opt) {
        answers[step] = opt.getAttribute('data-v');
        $$('.quiz-opt', mount).forEach(function (o) { o.classList.remove('selected'); });
        opt.classList.add('selected');
        var n = $('[data-quiz-next]', mount); if (n) n.disabled = false;
      } else if (nx && !nx.disabled) {
        step++; renderStep();
      } else if (bk && !bk.disabled) {
        step = Math.max(0, step - 1); renderStep();
      }
    });

    renderStep();
  });
})();
